import React from 'react';
import { useTheme } from '@mui/material';
import { ClienteData } from './types';
import DrillDownTopPartnersChart from './DrillDownTopPartnersChart';

interface DrillDownTopCustomersChartProps {
  clientes: ClienteData[];
  title?: string;
  maxItems?: number;
  height?: number;
  gridSize?: {
    xs?: number;
    md?: number;
  };
}

const DrillDownTopCustomersChart: React.FC<DrillDownTopCustomersChartProps> = ({
  clientes,
  title = "Top 10 Clientes do Período",
  maxItems = 10,
  height = 400,
  gridSize = { xs: 12, md: 12 }
}) => {
  const theme = useTheme();

  

  return (
    <DrillDownTopPartnersChart
      data={clientes}
      valueKey="valor_vendas"
      nameKey="nome"
      indexKey="cliente"
      barKey="Valor Vendas"
      color={theme.palette.primary.main}
      title={title}
      maxItems={clientes.length}
      height={height}
      gridSize={gridSize}
    />
  );
};

export default DrillDownTopCustomersChart; 